import React, {Component} from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { styles } from './Znicz.scss';


class Znicz extends Component {  
    render() {
        return (
            <div className="Column">
                <div className="fl1"></div>
                <div className="znicz"></div>
            </div>
        );
    }
}

export default withStyles(styles)(Znicz);



// WEBPACK FOOTER //
// src/components/MapControl/gravePopup/Znicz.js